import React from "react";
import { Routes, Route } from "react-router-dom";
import UiDemo from "../components/_uiMocks/UiDemo";
import { LoginPage } from "../components/_uiMocks/pages/Auth/LoginPage";
import { SignUpPage } from "../components/_uiMocks/pages/Auth/SignUpPage";
import { SignUpPageStepTwo } from "../components/_uiMocks/pages/Auth/SignUpPageStepTwo";
import HomePage from "../components/_uiMocks/pages/Home/HomePage"
import IncentivesHome from "../components/_uiMocks/pages/incentives/IncentivesHomeWrapper"
import IncentivesPreRegister from "../components/_uiMocks/pages/incentives/IncentivesPreRegister";
import IncentivesLeagueIndividual from "../components/_uiMocks/pages/incentives/IncentivesLeagueIndividual";
import IncentivesLeagueTeam from "../components/_uiMocks/pages/incentives/IncentivesLeagueTeam";
import { IncentiveSpinWin } from "../components/_uiMocks/pages/incentives/IncentiveSpin&Win";
import {IncentiveDirectWin} from "../components/_uiMocks/pages/incentives/IncentiveDirectWin"
import { IncentivesBanded } from "../components/_uiMocks/pages/incentives/IncentivesBanded";
import Wheel from "../components/_uiMocks/pages/Spinwheel/Wheel"
import { KnowledgeDashboard } from "../components/_uiMocks/pages/Knowledge/KnowledgeDashboard";
import { QuizzersAll } from "../components/_uiMocks/pages/Knowledge/QuizzersAll";
import { QuizzersCompleted } from "../components/_uiMocks/pages/Knowledge/QuizzersCompleted";
import { QuizHome } from "../components/_uiMocks/pages/Knowledge/QuizHome";
import { SelectCorrectImage } from "../components/_uiMocks/pages/Knowledge/SelectImageTemplate";
import { TemplateVideoMCQ } from "../components/_uiMocks/pages/Knowledge/TemplateVideoMCQ";
import { TemplateImageMCQ } from "../components/_uiMocks/pages/Knowledge/TemplateImageMCQ";
import { TemplateRange } from "../components/_uiMocks/pages/Knowledge/TemplateRange";
import { TemplateOpenQuestion } from "../components/_uiMocks/pages/Knowledge/TemplateOpenQuestion";
import { TemplateFeedback } from "../components/_uiMocks/pages/Knowledge/TemplateFeedback";
import { TemplateSectionDevider } from "../components/_uiMocks/pages/Knowledge/TemplateSectionDevider";
import { TemplateAssesmentFailed } from "../components/_uiMocks/pages/Knowledge/TemplateAssesmentFailed";
import { TemplateAssesmentPassed } from "../components/_uiMocks/pages/Knowledge/TemplateAssesmentPassed";
import LandingPage from "../components/_uiMocks/pages/LandingPage";
import ShopWrapper from "../components/_uiMocks/pages/Shop/ShopWrapper"
import BrowseProducts from "../components/_uiMocks/pages/Shop/BrowseProducts"
import MembershipWrapper from "../components/_uiMocks/pages/Shop/MembershipsWrapper"
import ProductInformation from "../components/_uiMocks/pages/Shop/ProductInformation"
import OrderConfirmation from"../components/_uiMocks/pages/Shop/OrderConfirmation"
import OrderCheckout from "../components/_uiMocks/pages/Shop/OrderCheckout"
import OrderDetails from "../components/_uiMocks/pages/Shop/OrderDetails"
// import VoucherWallet from "../components/_uiMocks/pages/Shop/VoucherWallet"
import { TemplateSectionDividerWithImage } from "../components/_uiMocks/pages/Knowledge/TemplateSectionDividerWithImage";
import { TemplateMCQMultiple } from "../components/_uiMocks/pages/Knowledge/TemplateMcqMultiple";
import { TemplateQUestionImageMultipleSelect } from "../components/_uiMocks/pages/Knowledge/TemplateQuestionImageMultiple";
import LoyaltyHome from "../components/_uiMocks/pages/Loyalty/LoyaltyHome"
import LoyaltyHomeSignedUp from "../components/_uiMocks/pages/Loyalty/LoyaltyHomeSignedUp"
import { PointsBanking } from "../components/_uiMocks/pages/PointsBanking/PointsBanking";
import LoyaltyStore from "../components/_uiMocks/pages/Loyalty/LoyaltyStore"
import {ViewBadges} from "../components/_uiMocks/pages/Knowledge/ViewBadges"
import {ViewBadgesDetails} from "../components/_uiMocks/pages/Knowledge/ViewBadgesDetails"
import { GoalInProgress } from "../components/_uiMocks/pages/Goal/GoalInProgress";
import { GoalMet } from "../components/_uiMocks/pages/Goal/GoalMet";
import { ViewQuizzersBadges } from "../components/_uiMocks/pages/Knowledge/Badges/ViewQuizzersBadges";
import { ViewQuizzersBadgesInProgress } from "../components/_uiMocks/pages/Knowledge/Badges/ViewQuizzersBadgesInprogress";
import { ViewQuizzersBadgesCompleted } from "../components/_uiMocks/pages/Knowledge/Badges/ViewQuizzersBadgesCompleted";
import { HomeBadges } from "../components/_uiMocks/pages/Knowledge/Badges/HomeBadges";
import { CourseEnded } from "../components/_uiMocks/pages/Knowledge/Badges/CourseEnded";
import { CourseInProgress } from "../components/_uiMocks/pages/Knowledge/Badges/CoursesInProgress";
import { CourseAssesmentPassed } from "../components/_uiMocks/pages/Knowledge/Badges/CourseAssesmentPassed";
import { CourseAssesmentFailed } from "../components/_uiMocks/pages/Knowledge/Badges/CourseAssesmentFailed";
import { CourseQuizLandingPage } from "../components/_uiMocks/pages/Knowledge/Badges/CourseQuizLandingPage";
import { CourseLandingPageCompleted } from "../components/_uiMocks/pages/Knowledge/Badges/CourseLandingPageCompleted";
import {BadgesDashboard} from "../components/_uiMocks/pages/Knowledge/BadgesDashboard";
import IncentivesPrizeDraw from "../components/_uiMocks/pages/incentives/IncentivesPrizeDraw";
import IncentivesPrizeDrawWinner from "../components/_uiMocks/pages/incentives/IncentivesPrizeDrawWinner";
import CommsPage from "../components/_uiMocks/pages/CommsPage/CommsPage";
import MyCart from "../components/_uiMocks/pages/Shop/MyCart"; 
import LeagueIncentives from "../components/_uiMocks/pages/incentives/custom/LeagueIncentives";
import ProductTargetIncentives from "../components/_uiMocks/pages/incentives/custom/ProductTargetIncentives";
import CustomBrowseProducts from "../components/_uiMocks/pages/Shop/Custom/CustomBrowseProducts";
import VoucherWallet from "../components/_uiMocks/pages/Shop/Custom/VoucherWallet";
import RenaultLandingPage from "../components/_uiMocks/pages/RenaultLandingPage";
// import RenaultHomeWrapper from "../components/_uiMocks/pages/home-renault/RenaultHomeWrapper"
// import OtpWrapper from "../components/pages/auth/OtpWrapper";
// import ResetPasswordWrapper from "../components/pages/auth/ResetPasswordWrapper";
// import ForgotPasswordWrapper from "../components/pages/auth/ForgotPasswordWrapper";
import SignUpWrapper from "../components/pages/auth/SignUpWrapper";

export default function UiRoutes() {
    return (
        <Routes>
            <Route index element={<UiDemo />} />
            {/* <Route path="signup" element={<SignUpPage />} /> */}
            <Route path="signup-step-two" element={<SignUpPageStepTwo  />} />
            <Route path="login" element={<LoginPage />} />

            <Route path="home" element={<HomePage />} />
            <Route path="campaigns" element={<IncentivesHome />} />
            <Route path="incentives-pre-register" element={<IncentivesPreRegister />} />
            <Route path="incentives-league-individual" element={<IncentivesLeagueIndividual />} />
            <Route path="incentives-league-team" element={<IncentivesLeagueTeam />} />
            <Route path="incentives-spin-win-home" element={<IncentiveSpinWin />} />
            <Route path="incentives-direct-win" element={<IncentiveDirectWin />} />
            <Route path="incentives-prize-draw" element={<IncentivesPrizeDraw />} />
            <Route path="incentives-prize-draw-winner" element={<IncentivesPrizeDrawWinner />} />

            <Route path="incentives-banded" element={<IncentivesBanded />} />
            <Route path="incentives-spin-win" element={<Wheel/>} />
            <Route path="learn" element={<KnowledgeDashboard />} />
            <Route path="all-quizzers" element={<QuizzersAll />} />
            <Route path="completed-quizzers" element={<QuizzersCompleted />} />
            <Route path="quiz-home" element={<QuizHome />} />
            <Route path="correct-image-q-template" element={<SelectCorrectImage />} />
            <Route path="correct-image-q-template-multiple" element={<TemplateQUestionImageMultipleSelect />} />            
            <Route path="template-mcq-image" element={<TemplateImageMCQ />} />
            <Route path="template-mcq-video" element={<TemplateVideoMCQ />} />
            <Route path="template-mcq-multiple" element={<TemplateMCQMultiple />} />
            <Route path="template-range" element={<TemplateRange />} />
            <Route path="template-open-question" element={<TemplateOpenQuestion />} />
            <Route path="template-feedback" element={<TemplateFeedback />} />
            <Route path="template-section-divider" element={<TemplateSectionDevider />} />
            <Route path="template-section-divider-with-image" element={<TemplateSectionDividerWithImage />} />
            <Route path="template-assesment-failed" element={<TemplateAssesmentFailed />} />
            <Route path="template-assesment-passed" element={<TemplateAssesmentPassed />} />
            <Route path="landing-page" element={<LandingPage />} />
            <Route path="shop" element={<ShopWrapper />} />
            <Route path="browse-product" element={<BrowseProducts />} />
            <Route path="membership" element={<MembershipWrapper />} />
            <Route path="product-information" element={<ProductInformation />} />
            <Route path="order-confirmation" element={<OrderConfirmation/>}/>
            <Route path="order-checkout" element={<OrderCheckout/>}/>
            <Route path="order-details" element={<OrderDetails/>}/>
            <Route path="voucher-wallet" element={<VoucherWallet />}/>
            <Route path="loyalty" element={<LoyaltyHome />}/>
            <Route path="loyalty-home-signed-up" element={<LoyaltyHomeSignedUp />}/>
            <Route path="points-banking" element={<PointsBanking />}/>
            <Route path="loyalty-store" element={<LoyaltyStore />}/>
            <Route path="view-badges" element={<ViewBadges />}/>
            <Route path="view-badges-details" element={<ViewBadgesDetails/>}/>
            <Route path="goals-in-progress" element={<GoalInProgress />}/>
            <Route path="goals-met" element={<GoalMet />}/>
            <Route path="view-quizzers-badges" element={<ViewQuizzersBadges />}/>
            <Route path="view-quizzers-badges-completed" element={<ViewQuizzersBadgesCompleted />}/>
            <Route path="view-quizzers-badges-in-progress" element={<ViewQuizzersBadgesInProgress />}/>            
            <Route path="home-badges" element={<HomeBadges />}/>
            <Route path="course-end" element={<CourseEnded />}/>
            <Route path="course-in-progress" element={<CourseInProgress />}/>
            <Route path="course-completed" element={<CourseLandingPageCompleted />}/>
            <Route path="course-quiz-home" element={<CourseQuizLandingPage />}/>
            <Route path="course-assesment-passed" element={<CourseAssesmentPassed />}/>
            <Route path="course-assesment-failed" element={<CourseAssesmentFailed />}/>
            <Route path="badges-dashboard" element={<BadgesDashboard />}/>
            <Route path="comms-page" element={<CommsPage />}/>
            <Route path="mycart" element={<MyCart/>}/>
            <Route path="product-target-incentives" element={<ProductTargetIncentives/>}/>
            <Route path="league-incentives/250" element={<LeagueIncentives/>}/>
            <Route path="custom-browse-products" element={<CustomBrowseProducts/>}/>
            <Route path="voucher-wallet" element={<VoucherWallet/>}/>
            <Route path="renault-landing" element={<RenaultLandingPage />}/>
            {/* <Route path="otp-verify" element={<OtpWrapper />}/>
            <Route path="forgot-password" element={<ForgotPasswordWrapper />}/>
            <Route path="reset-password" element={<ResetPasswordWrapper />}/> */}
            <Route path="signup" element={<SignUpWrapper />}/> 
           
           

        </Routes>
    );
}
